import { useState } from "react";
import {
  IconX,
  IconSend,
  IconUser,
  IconBriefcase,
  IconPlugConnectedX,
  IconNotes,
} from "@tabler/icons-react";
import { errorHandler } from "../../../utils";
import { reportHireLeft } from "../../../services/clientCalls";
import styles from "../cancelMatchModal/cancelMatchModal.module.css";
import Button from "../../UI/Button/button";
import { Textarea } from "../../UI/FormInput/input";

// 30-day rematch guarantee: the client reports that their hire left, the job
// reopens, and its next match costs half the credits when it's covered.
const HireLeftModal = ({ applicantId, talentName, jobTitle, setShowModal, onReported }) => {
  const [load, setLoad] = useState(false);
  const [reason, setReason] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoad(true);
    try {
      const res = await reportHireLeft(applicantId, reason.trim() || undefined);
      if (res.data?.success) {
        setShowModal(false);
        onReported(res.data.data);
      }
    } catch (error) {
      error.response?.data
        ? errorHandler(error.response.data.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    } finally {
      setLoad(false);
    }
  };

  return (
    <div
      className={styles.modalBackdrop}
      onClick={(e) => {
        if (e.target === e.currentTarget) setShowModal(false);
      }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="hlTitle"
    >
      <div className={styles.modalCard}>
        <button
          className={styles.modalClose}
          aria-label="Close"
          onClick={() => setShowModal(false)}
          type="button"
        >
          <IconX size={17} />
        </button>

        <div className={styles.cmHero} aria-hidden="true">
          <div className={styles.cmHeroStage}>
            <div className={styles.cmNodeLeft}>
              <IconUser size={20} />
            </div>
            <div className={styles.cmLink} />
            <div className={styles.cmRing} />
            <div className={`${styles.cmRing} ${styles.cmRingSecond}`} />
            <div className={styles.cmBadge}>
              <IconPlugConnectedX size={18} />
            </div>
            <div className={styles.cmNodeRight}>
              <IconBriefcase size={20} />
            </div>
          </div>
        </div>

        <div className={styles.cmHeading}>
          <div className={styles.cmHeadingTitle} id="hlTitle">
            Did {talentName || "your hire"} leave?
          </div>
          <div className={styles.cmHeadingSub}>
            We'll reopen {jobTitle ? `"${jobTitle}"` : "this job"} so you can match again. With our
            30-day rematch guarantee, the next match costs half the credits (once per job; free-trial
            matches aren't covered).
          </div>
        </div>

        <div className={styles.modalBody}>
          <form id="hireLeftForm" onSubmit={handleSubmit}>
            <div className={styles.field}>
              <Textarea
                label="What happened? (optional)"
                labelIcon={<IconNotes size={14} />}
                id="hlReason"
                rows={4}
                maxLength={500}
                placeholder="e.g. Resigned in week two"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </div>

            <div className={styles.modalFoot}>
              <Button
                variant="ghostFilled"
                size="lg"
                onClick={() => setShowModal(false)}
              >
                Keep Hire
              </Button>
              <Button
                variant="dangerSolid"
                size="lg"
                leftIcon={<IconSend size={15} />}
                loading={load}
                disabled={!applicantId}
                onClick={handleSubmit}
              >
                Report Hire Left
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default HireLeftModal;
